/* eslint-disable object-curly-newline */
import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip, mergeClasses } from '@fluentui/react-components';
import { useStyle } from './styles';

export const splitString = (text, substr) => {
  //
  if (!text || !substr || _.isEmpty(substr)) {
    return [{ matched: false, text, idx: 0 }];
  }

  // case-insensitive
  const lowerText = text.toLowerCase();
  const lowerSubstr = substr.toLowerCase();

  let startIndex = 0;
  const fragments = [];

  while (startIndex < text.length) {
    const index = lowerText.indexOf(lowerSubstr, startIndex);
    if (index === -1) {
      fragments.push({ matched: false, text: text.substring(startIndex) });
      break;
    } else if (index > startIndex) {
      fragments.push({ matched: false, text: text.substring(startIndex, index) });
      fragments.push({ matched: true, text: text.substring(index, index + substr.length) });
      startIndex = index + substr.length;
    } else {
      fragments.push({ matched: true, text: text.substring(index, index + substr.length) });
      startIndex = index + substr.length;
    }
  }

  // add an idx field for each fragment
  const fragmentsWithIndex = fragments.map((f, idx) => ({ ...f, idx }));
  return fragmentsWithIndex;
};

export const TextWithHighlightImp = ({
  text: txt, highlightedText, highlightedClassname, enableTooltip,
}) => {
  const textFragments = splitString(txt, highlightedText);

  const content = (
    <span className="highlight-text-content">
      {
        textFragments.map(({ matched, text, idx }) =>
          <span key={`f${idx}`} className={matched ? mergeClasses('highlighted-text', highlightedClassname) : 'normal-text'}>{text}</span>)
      }
    </span>
  );

  const classes = useStyle();

  return enableTooltip ? (
    <Tooltip
      content={<span className="highlight-tooltip-content">{txt}</span>}
      relationship="inaccessible"
      withArrow
      positioning="above-start"
    >
      <div className={classes.overflow}>
        {content}
      </div>
    </Tooltip>
  ) : content;
};

TextWithHighlightImp.propTypes = {
  text: PropTypes.string,
  highlightedText: PropTypes.string,
  highlightedClassname: PropTypes.string,
  enableTooltip: PropTypes.bool,
};

TextWithHighlightImp.defaultProps = {
  text: '',
  highlightedText: undefined,
  highlightedClassname: 'highlighted-text',
  enableTooltip: false,
};

export const TextWithHighlight = TextWithHighlightImp;
